import { Injectable } from '@angular/core';
import { forIn, has } from 'lodash';
import { VariablesResource } from '../../account/resources/variables.resource';
import { NotifyService } from '../../common/services/notify.service';

const predefined = [
  {
    key: '_ACCOUNT_ID',
    help: 'The internal id of the account under which the package and job were created.',
  },
  {
    key: '_ACCOUNT_ID_S3_ESCAPED',
    help: 'The S3 escaped internal id of the account under which the package and job were created.﻿',
  },
  {
    key: '_ACCOUNT_NAME',
    help: 'The name of the account under which the package and job were created.',
  },
  {
    key: '_ACCOUNT_NAME_S3_ESCAPED',
    help: 'The S3 escaped name of the account under which the package and job were created.',
  },
  {
    key: '_CLUSTER_ID',
    help: 'The ID of the cluster on which the job is running.',
  },
  {
    key: '_CLUSTER_ID_S3_ESCAPED',
    help: 'The S3 escaped ID of the cluster on which the job is running.',
  },
  {
    key: '_CLUSTER_NODES_COUNT',
    help: 'The number of nodes in the cluster that executes the job.',
  },
  {
    key: '_JOB_ID',
    help: 'Xplenty Job Identifier.',
  },
  {
    key: '_JOB_ID_S3_ESCAPED',
    help: 'S3 escaped Xplenty Job Identifier.',
  },
  {
    key: '_JOB_SUBMISSION_TIMESTAMP',
    help: 'ISO-8601 date-time value of the time the job was submitted in UTC. For example: 2013-04-22T14:18:17Z',
  },
  {
    key: '_JOB_SUBMISSION_TIMESTAMP_S3_ESCAPED',
    help: 'S3 escaped date-time value of the time the job was submitted in UTC. For example: 2013-01-09T14-52-21Z',
  },
  {
    key: '_JOB_SUBMITTER_EMAIL',
    help: 'The email address of the user who submitted the job. For example: helpdesk@xplenty.com',
  },
  {
    key: '_JOB_SUBMITTER_EMAIL_S3_ESCAPED',
    help: 'The S3 escaped email address of the user who submitted the job. For example: helpdesk-xplenty-com',
  },
  {
    key: '_PACKAGE_LAST_SUCCESSFUL_JOB_SUBMISSION_TIMESTAMP',
    help: '',
  },
  {
    key: '_PACKAGE_OWNER_EMAIL',
    help: 'The email address of the user who owns the package.',
  },
  {
    key: '_PACKAGE_OWNER_EMAIL_S3_ESCAPED',
    help: 'The S3 escaped email address of the user who owns the package.',
  },
];

@Injectable({
  providedIn: 'root',
})
export class VariablesService {
  systems = null;

  constructor(private variablesResource: VariablesResource, private notifyService: NotifyService) {}

  getSystems(callback) {
    if (this.systems) {
      callback(this.systems);
    } else {
      this.variablesResource.get().subscribe(
        (items) => {
          this.systems = items;
          callback(this.systems);
        },
        (err) => {
          this.notifyService.error('Failed to load system variables');
        },
      );
    }
  }

  separateVariables(vars, defaultVars, usePackageDefault, callback) {
    this.getSystems((systems) => {
      const result = {
        systemVariables: [],
        userVariables: [],
        predefinedVariables: predefined,
      };
      forIn(vars, (value, key) => {
        if (has(systems, key)) {
          return;
        }
        result.userVariables.push({
          key,
          value,
          // eslint-disable-next-line no-nested-ternary
          default: usePackageDefault ? (has(defaultVars, key) ? defaultVars[key] : value) : value,
        });
      });

      forIn(systems, (value, key) => {
        result.systemVariables.push({
          key,
          value: has(vars, key) ? vars[key] : value,
          default: value, // usePackageDefault ? (_.has(vars, key) ? vars[key] : value) : value,
          type: 'string',
        });
      });

      callback(result);
    });
  }

  combineVariables(users, systems, callback) {
    this.getSystems((defaults) => {
      const result = {};
      users.forEach((v) => {
        result[v.key] = v.value;
      });
      systems.forEach((v) => {
        if (v.value !== defaults[v.key]) {
          result[v.key] = v.value;
        }
      });
      callback(result);
    });
  }
}
